import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import {DemoService} from '../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';
// import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
// ag- table component
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { enableRipple } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager, ODataAdaptor, WebApiAdaptor, UrlAdaptor,Query, ReturnOption  } from '@syncfusion/ej2-data';
import { MenuItemModel } from '@syncfusion/ej2-angular-navigations';
import { PageSettingsModel, FilterSettingsModel } from '@syncfusion/ej2-grids';

import { ChangeEventArgs } from '@syncfusion/ej2-inputs';
import { createElement } from '@syncfusion/ej2-base';
import {  IFilter, TextWrapSettingsModel } from '@syncfusion/ej2-angular-grids';
import { GridComponent, ToolbarItems, ToolbarService, ExcelExportService, GroupSettingsModel,
RowDataBoundEventArgs  } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';
import { delay, forkJoin, map } from 'rxjs';

import { FilterService, IFilterUI, Column } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { parentsUntil } from '@syncfusion/ej2-grids';
import { GlobalFunctionsService } from './../../services/global-functions.service';
import { ClientApiAdminClient, ClientApiAdminService } from '../../services/client-api-admin.service';

@Component({
  selector: 'app-companies-home',
  templateUrl: './companies-home.component.html',
  styleUrls: ['./companies-home.component.css'],
  providers: [ToolbarService, ExcelExportService]
})
export class CompaniesHomeComponent implements OnInit {

  job_table: any;
  result: any;
  client_name: any;
  persons: any;
  job_table2: any;
  client_name_value: any;
 responseDelay = 2000;
  clients: any;
  clientLocalRecord: any;
  job_types: any;
  subjects: any;
  agents_assigned: any;
  staffList: any;
  items: Object[];
  data_subjects2: any;
  initialPage: PageSettingsModel;

  jobTypesLocalRecord: any;
  changeObject: any;

  subjectLocalRecord: any;

  createdAt: any;
  nextDateLocalRecord: any;

  agentsAssignedLocalRecord: any;
  allocated_agents_list: any;

  public data: DataManager;
  public data_subjects: DataManager;
  public pageSettings: Object;
  public pageOptions = { pageSize: 100 }; 
  public filterOptions: FilterSettingsModel;
  public formatOptions: Object;
  // public filterOptions: FilterSettingsModel;
  public filter : IFilter;
  public toolbarOptions: ToolbarItems[];
  @ViewChild('grid')
  public grid: GridComponent;
  public groupOptions: GroupSettingsModel;
  public templateOptionsDate: IFilterUI;
  public elem1: HTMLElement;
  public datePickerObj: DatePicker;
  job_table3: any;
  brand_types: any;
  btLocalRecord: any;
  users: any;
  userLocalRecord: any;
  userPrimaryLocalRecord: any;
  usersPrimary: any;
  job_table_clients: any;
  job_table_clents3: any;
  job_table_clients3: any;
  job_table_agents: any;
  job_table_agents3: any;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;
  isAdminRoute = false;

  modalRef: BsModalRef;
  clientApiBaseUrl = '';
  clientApiAdminBrokerUrl = '';
  clientApiLoading = false;
  clientApiMessage = '';
  clientApiError = '';
  clientApiGeneratedSecret = '';
  clientApiGeneratedClientUuid = '';
  clientApiGeneratedClientName = '';
  clientApiGeneratedEnvironment = '';
  clientApiGeneratedAt = '';
  clientApiClients: ClientApiAdminClient[] = [];
  clientApiClientsByBrand: { [brandId: string]: ClientApiAdminClient[] } = {};
  clientApiAllStateLoaded = false;
  clientApiBrandsLoaded: { [brandId: string]: boolean } = {};
  clientApiStatusData: any = null;
  clientApiOperationsData: any = null;
  selectedClientApiBrand: any;
  selectedBrandApiClients: ClientApiAdminClient[] = [];
  selectedBrandApiAccessControl: any = null;
  selectedBrandApiAccessReason = '';
  selectedBrandLiveTestControl: any = null;
  selectedBrandLiveTestReason = '';
  selectedClientApiEditClient: ClientApiAdminClient = null;
  selectedClientApiActivity: any = null;
  selectedClientApiActivityClient: ClientApiAdminClient = null;
  clientApiCreateName = '';
  clientApiForm: any = {
    so_user_id: null,
    environment_mode: 'sandbox',
    sync_enabled: false,
    status: 'active',
    scopes: {
      jobsCreate: true,
      jobsRead: true,
      subjectsRead: true,
      logsRead: true,
      docsRead: true,
      notesRead: false,
      notesCreate: false,
      documentsRead: false,
      documentsUpload: false,
      actionsUpdateRequest: false,
      actionsSubjectWorkflow: false,
      actionsCloseFile: false
    }
  };

  readonly clientApiScopeOptions = [
    { key: 'jobsCreate', scope: 'jobs:create', label: 'Create jobs' },
    { key: 'jobsRead', scope: 'jobs:read', label: 'Read jobs/lookups' },
    { key: 'subjectsRead', scope: 'subjects:read', label: 'Read subjects' },
    { key: 'logsRead', scope: 'client-api:logs:read', label: 'Read API logs' },
    { key: 'docsRead', scope: 'docs:read', label: 'Read docs' },
    { key: 'notesRead', scope: 'notes:read', label: 'Read notes' },
    { key: 'notesCreate', scope: 'notes:create', label: 'Create notes' },
    { key: 'documentsRead', scope: 'documents:read', label: 'Read documents' },
    { key: 'documentsUpload', scope: 'documents:upload', label: 'Upload documents' },
    { key: 'actionsUpdateRequest', scope: 'actions:update_request', label: 'Request updates' },
    { key: 'actionsSubjectWorkflow', scope: 'actions:subject_workflow', label: 'Subject workflow actions' },
    { key: 'actionsCloseFile', scope: 'actions:close_file', label: 'Request closure' }
  ];

  public wrapSettings: TextWrapSettingsModel;

  constructor(
    private http: HttpClient, private router: Router, route: ActivatedRoute,private _demoService: DemoService,
    public datepipe: DatePipe,
    public gfunc: GlobalFunctionsService,
    private modalService: BsModalService,
    private clientApiAdmin: ClientApiAdminService
  ) { 

// Set and Access login Session Variables
this.gfunc.setLoginSessionVars(); // set in a global function file
this.sessionUserId = this.gfunc.currentUserVAR.user_id;
this.sessionUsername = this.gfunc.currentUserVAR.username;
this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

// need to add this as routes does not work globally
this.all_router_details = this.router.url;
this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));
this.isAdminRoute = this.router.url.indexOf('/admin/') === 0;
this.clientApiBaseUrl = this.clientApiAdmin.selectedBaseUrl;
this.clientApiAdminBrokerUrl = this.clientApiAdmin.brokerBaseUrl;


  }

  ngOnInit() {

    this.mapJobTableLive(); // load the table data
    this.mapJobTableLiveClients();
    this.mapJobTableLiveAgents();
    

    this.wrapSettings = { wrapMode: 'Content' };
    this.toolbarOptions = ['ExcelExport', 'Search'];
    this.initialPage = { pageSize:5 };
    this.filterOptions = {
      type: 'Menu'
   };
  // this.groupOptions = { columns: ['job_id'] }; // sets auto grouping for the grid
   this.formatOptions= {type:'date', format:'dd/MM/yyyy'};
   this.wrapSettings = { wrapMode: 'Content' }; // this allows the content to wrap only Header|Content|Both
  }
  



// New way of rendering table data
mapJobTableLive() {

  this.getBrandBrandTypes();
  this.getUsers();
  

  this.http.get<any>(this.gfunc.apiURL + '/api/brands')
 .pipe(map(data => {
  // do your transformations
  this.job_table2 = data;

  this.job_table2.forEach(element => {
    element.primary_contact = ''; // removed undefined from table

/*
// local Client Name
this.clientLocalRecord = this.clients.filter(c => c.client_id === element.client_id);
let rs = this.clientLocalRecord;
this.changeObject = Object.assign(this.clientLocalRecord);
element.client_id  = this.changeObject[0].name;
*/
this.btLocalRecord = this.brand_types.filter(c => c.brand_type_id === element.brand_type_id);
this.changeObject = Object.assign(this.btLocalRecord);
  element.brand_type_key = Number(element.brand_type_id);
  element.brand_type_id  = this.changeObject[0].brand_type_name;

// get user counts per brand
this.userLocalRecord = this.users.filter(c => c.brand_id === element.brand_id);
this.changeObject = Object.assign(this.userLocalRecord);
let recordCount = this.changeObject.length;
element.contacts  = this.changeObject.length;



// get user counts per brand
this.userLocalRecord = this.users.filter(c => c.brand_id === element.brand_id && c.is_primary_contact == 1);
this.changeObject = Object.assign(this.userLocalRecord);
let recordCount2 = this.changeObject.length;
// element.contacts  = this.changeObject.length;
// need to filter this element objects of users to get the primary contact.
if (recordCount2 < 1){
  element.primary_contact = '-';
}else{
  for (let i = 0; i < recordCount2; i++) {
    element.primary_contact  += this.changeObject[i].first_name + ' ' + this.changeObject[i].surname + ', ';
} // end loop
}// end if


}); // end for each of all

this.applyClientApiState(this.job_table2);

return this.job_table3;
})
 ) // end pipe
  .subscribe(results => this.job_table3 = results
  );

}






// New way of rendering table data
mapJobTableLiveClients() {

  this.getBrandBrandTypes();
  this.getUsers();
  

  this.http.get<any>(this.gfunc.apiURL + '/api/brands/clients')
 .pipe(map(data => {
  // do your transformations
  this.job_table_clients = data;

  this.job_table_clients.forEach(element => {
    element.primary_contact = ''; // removed undefined from table

/*
// local Client Name
this.clientLocalRecord = this.clients.filter(c => c.client_id === element.client_id);
let rs = this.clientLocalRecord;
this.changeObject = Object.assign(this.clientLocalRecord);
element.client_id  = this.changeObject[0].name;
*/
this.btLocalRecord = this.brand_types.filter(c => c.brand_type_id === element.brand_type_id);
this.changeObject = Object.assign(this.btLocalRecord);
  element.brand_type_key = Number(element.brand_type_id);
  element.brand_type_id  = this.changeObject[0].brand_type_name;

// get user counts per brand
this.userLocalRecord = this.users.filter(c => c.brand_id === element.brand_id);
this.changeObject = Object.assign(this.userLocalRecord);
let recordCount = this.changeObject.length;
element.contacts  = this.changeObject.length;



// get user counts per brand
this.userLocalRecord = this.users.filter(c => c.brand_id === element.brand_id && c.is_primary_contact == 1);
this.changeObject = Object.assign(this.userLocalRecord);
let recordCount2 = this.changeObject.length;
// element.contacts  = this.changeObject.length;
// need to filter this element objects of users to get the primary contact.
if (recordCount2 < 1){
  element.primary_contact = '-';
}else{
  for (let i = 0; i < recordCount2; i++) {
    element.primary_contact  += this.changeObject[i].first_name + ' ' + this.changeObject[i].surname + ', ';
} // end loop
}// end if


}); // end for each of all

this.applyClientApiState(this.job_table_clients);

return this.job_table_clients3;
})
 ) // end pipe
  .subscribe(results => this.job_table_clients3 = results
  );

}



// New way of rendering table data
mapJobTableLiveAgents() {

  this.getBrandBrandTypes();
  this.getUsers();
  

  this.http.get<any>(this.gfunc.apiURL + '/api/brands/agents')
 .pipe(map(data => {
  // do your transformations
  this.job_table_agents = data;

  this.job_table_agents.forEach(element => {
    element.primary_contact = ''; // removed undefined from table

/*
// local Client Name
this.clientLocalRecord = this.clients.filter(c => c.client_id === element.client_id);
let rs = this.clientLocalRecord;
this.changeObject = Object.assign(this.clientLocalRecord);
element.client_id  = this.changeObject[0].name;
*/
this.btLocalRecord = this.brand_types.filter(c => c.brand_type_id === element.brand_type_id);
this.changeObject = Object.assign(this.btLocalRecord);
  element.brand_type_key = Number(element.brand_type_id);
  element.brand_type_id  = this.changeObject[0].brand_type_name;

// get user counts per brand
this.userLocalRecord = this.users.filter(c => c.brand_id === element.brand_id);
this.changeObject = Object.assign(this.userLocalRecord);
let recordCount = this.changeObject.length;
element.contacts  = this.changeObject.length;



// get user counts per brand
this.userLocalRecord = this.users.filter(c => c.brand_id === element.brand_id && c.is_primary_contact == 1);
this.changeObject = Object.assign(this.userLocalRecord);
let recordCount2 = this.changeObject.length;
// element.contacts  = this.changeObject.length;
// need to filter this element objects of users to get the primary contact.
if (recordCount2 < 1){
  element.primary_contact = '-';
}else{
  for (let i = 0; i < recordCount2; i++) {
    element.primary_contact  += this.changeObject[i].first_name + ' ' + this.changeObject[i].surname + ', ';
} // end loop
}// end if


}); // end for each of all

this.applyClientApiState(this.job_table_agents);

return this.job_table_agents3;
})
 ) // end pipe
  .subscribe(results => this.job_table_agents3 = results
  );

}







toolbarClick(args: ClickEventArgs): void {
  if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
      this.grid.excelExport();
  }
}
rowDataBound(args: RowDataBoundEventArgs) {
  const job_status = 'job_status';
  if (args.data[job_status] === 'CLOSED') {
      args.row.className = 'strikethrough';
  }
}

refreshGrid(){ // refresh the databutton
  this.mapJobTableLive();
  this.grid.refresh();
};




getBrandBrandTypes(){
  this._demoService.getBrandBrandTypes().subscribe(
    data => { this.brand_types = data;
     let res = data[0];
   },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}

getUsers() {
  this._demoService.getUsers().subscribe(
    data => { this.users = data;
      this.usersPrimary = data;
     let res = data[0];
   },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}

  clientApiTargetChanged(): void {
    this.clientApiClients = [];
    this.clientApiClientsByBrand = {};
    this.clientApiAllStateLoaded = false;
    this.clientApiBrandsLoaded = {};
    this.selectedBrandApiClients = [];
  this.clearClientApiGeneratedCredentials();
  this.clientApiMessage = '';
  this.clientApiError = '';
  this.selectedClientApiEditClient = null;
  this.selectedClientApiActivity = null;
  this.selectedClientApiActivityClient = null;
  this.selectedBrandApiAccessControl = null;
  this.selectedBrandApiAccessReason = '';
  this.clientApiOperationsData = null;
  this.refreshClientApiBadges();
}

loadClientApiStatus(showMessage: boolean = true): void {
  if (!this.isAdminRoute) {
    return;
  }

  this.clientApiLoading = true;
  this.clientApiMessage = '';
  this.clientApiError = '';
  this.clientApiAdmin.status().subscribe({
    next: response => {
      this.clientApiStatusData = response && response.data ? response.data : null;
      this.clientApiLoading = false;
      if (showMessage) {
        this.clientApiMessage = 'Client API status loaded.';
      }
    },
    error: error => this.handleClientApiError(error, 'Client API status failed to load.')
  });
}

loadClientApiClients(showMessage: boolean = true): void {
  if (!this.isAdminRoute) {
    return;
  }

  this.clientApiLoading = true;
  this.clientApiMessage = '';
  this.clientApiError = '';
  this.clientApiAdmin.listClients(this.clientApiBaseUrl, 200).subscribe({
    next: response => {
      this.clientApiClients = response && response.data && response.data.clients ? response.data.clients : [];
      this.clientApiAllStateLoaded = true;
      this.rebuildClientApiMap();
      this.refreshClientApiBadges();
      this.refreshSelectedBrandClients();
      this.clientApiLoading = false;
      if (showMessage) {
        this.clientApiMessage = 'Client API access state loaded.';
      }
    },
    error: error => this.handleClientApiError(error, 'Client API access state failed to load.')
  });
}

loadClientApiOperations(showMessage: boolean = true): void {
  if (!this.isAdminRoute) {
    return;
  }

  this.clientApiLoading = true;
  this.clientApiMessage = '';
  this.clientApiError = '';
  this.clientApiAdmin.operations(25).subscribe({
    next: response => {
      this.clientApiOperationsData = response && response.data ? response.data : null;
      this.clientApiStatusData = this.clientApiAdmin.runtimeFromOperations(response);
      this.clientApiLoading = false;
      if (showMessage) {
        this.clientApiMessage = 'Client API operations loaded.';
      }
    },
    error: error => this.handleClientApiError(error, 'Client API operations failed to load.')
  });
}

openClientApiModal(template: TemplateRef<any>, brand: any): void {
  if (!this.isAdminRoute) {
    return;
  }
  if (!this.isClientBrand(brand)) {
    this.clientApiMessage = '';
    this.clientApiError = 'Client API access can only be managed for companies with brand type Client.';
    return;
  }

  this.selectedClientApiBrand = brand;
  this.clientApiCreateName = ((brand && brand.name) ? brand.name : 'Client') + ' Client API';
  this.clearClientApiGeneratedCredentials();
  this.clientApiMessage = '';
  this.clientApiError = '';
  this.selectedClientApiEditClient = null;
  this.selectedClientApiActivity = null;
  this.selectedClientApiActivityClient = null;
  this.clientApiForm = {
    so_user_id: null,
    environment_mode: 'sandbox',
    sync_enabled: false,
    status: 'active',
    scopes: {
      jobsCreate: true,
      jobsRead: true,
      subjectsRead: true,
      logsRead: true,
      docsRead: true,
      notesRead: false,
      notesCreate: false,
      documentsRead: false,
      documentsUpload: false,
      actionsUpdateRequest: false,
      actionsSubjectWorkflow: false,
      actionsCloseFile: false
    }
  };
  this.refreshSelectedBrandClients();

  this.modalRef = this.modalService.show(template, {
    backdrop: true,
    ignoreBackdropClick: true,
    class: 'gray modal-xl client-api-access-modal'
  });

  this.loadSelectedBrandApiClients(false);
}

  loadSelectedBrandApiClients(showMessage: boolean = true): void {
  if (!this.selectedClientApiBrand) {
    return;
  }

  const brandId = Number(this.selectedClientApiBrand.brand_id);
  this.clientApiLoading = true;
  this.clientApiMessage = '';
  this.clientApiError = '';
  forkJoin({
    clients: this.clientApiAdmin.listClients(this.clientApiBaseUrl, 50, brandId),
    controls: this.clientApiAdmin.accessControls(brandId),
    liveTest: this.clientApiAdmin.liveTestControl(brandId)
  }).subscribe({
    next: result => {
      const response = result.clients;
      const clients = response && response.data && response.data.clients ? response.data.clients : [];
      this.selectedBrandApiAccessControl = result.controls && result.controls.data ? result.controls.data : null;
      this.selectedBrandLiveTestControl = result.liveTest && result.liveTest.data ? result.liveTest.data : null;
      const brandControl = this.selectedBrandApiAccessControl && this.selectedBrandApiAccessControl.brand;
      this.selectedBrandApiAccessReason = brandControl && brandControl.reason ? brandControl.reason : '';
      this.selectedBrandLiveTestReason = this.selectedBrandLiveTestControl && this.selectedBrandLiveTestControl.reason
        ? this.selectedBrandLiveTestControl.reason
        : '';
      this.clientApiBrandsLoaded[String(brandId)] = true;
      this.mergeClientApiClients(clients);
      this.refreshSelectedBrandClients();
      this.refreshClientApiBadges();
      this.clientApiLoading = false;
      if (showMessage) {
        this.clientApiMessage = 'Selected brand API state loaded.';
      }
    },
    error: error => this.handleClientApiError(error, 'Selected brand API state failed to load.')
  });
  }

setSelectedBrandApiBlocked(blocked: boolean): void {
  if (!this.selectedClientApiBrand) {
    return;
  }

  const brandId = Number(this.selectedClientApiBrand.brand_id || 0);
  const reason = this.selectedBrandApiAccessReason.trim();
  if (blocked && !reason) {
    this.clientApiError = 'Enter a security or operational reason before blocking this company.';
    this.clientApiMessage = '';
    return;
  }

  const company = this.selectedClientApiBrand.name || ('brand_id ' + brandId);
  const action = blocked ? 'block' : 'restore';
  if (!window.confirm('Confirm ' + action + ' Client API access for ' + company + '?')) {
    return;
  }

  this.clientApiLoading = true;
  this.clientApiMessage = '';
  this.clientApiError = '';
  this.clientApiAdmin.setBrandAccessControl(brandId, blocked, reason).subscribe({
    next: response => {
      this.selectedBrandApiAccessControl = response && response.data ? response.data : null;
      this.clientApiLoading = false;
      this.loadSelectedBrandApiClients(false);
      this.clientApiMessage = blocked
        ? 'Company Client API access blocked. Requests and queued processing are paused.'
        : 'Company Client API access restored. Eligible requests and queued processing can resume.';
    },
    error: error => this.handleClientApiError(error, 'Company Client API security control could not be updated.')
  });
}

setSelectedBrandLiveTestEnabled(enabled: boolean): void {
  if (!this.selectedClientApiBrand) {
    return;
  }

  const brandId = Number(this.selectedClientApiBrand.brand_id || 0);
  const company = this.selectedClientApiBrand.name || ('brand_id ' + brandId);
  const warning = enabled
    ? 'Enable hosted Live Testing for ' + company + '? Administrators will be able to create real Sharmans jobs, notes, files, notifications and automation events through an eligible Live credential.'
    : 'Disable hosted Live Testing for ' + company + '? Existing Client API credentials remain unchanged.';
  if (!window.confirm(warning)) {
    return;
  }

  this.clientApiLoading = true;
  this.clientApiMessage = '';
  this.clientApiError = '';
  this.clientApiAdmin.setLiveTestControl(brandId, enabled, this.selectedBrandLiveTestReason.trim()).subscribe({
    next: response => {
      this.selectedBrandLiveTestControl = response && response.data ? response.data : null;
      this.clientApiLoading = false;
      this.loadSelectedBrandApiClients(false);
      this.clientApiMessage = enabled
        ? 'Hosted Live Testing enabled for this company.'
        : 'Hosted Live Testing disabled for this company.';
    },
    error: error => this.handleClientApiError(error, 'Hosted Live Testing control could not be updated.')
  });
}

saveClientApiAccess(): void {
  if (!this.selectedClientApiBrand) {
    return;
  }
  if (!this.isClientBrand(this.selectedClientApiBrand)) {
    this.clientApiMessage = '';
    this.clientApiError = 'Client API credentials can only be assigned to a Client brand.';
    return;
  }

  const scopes = this.selectedClientApiScopes();
  if (scopes.length === 0) {
    this.clientApiError = 'Select at least one Client API scope.';
    this.clientApiMessage = '';
    return;
  }

  const soUserId = Number(this.clientApiForm.so_user_id || 0);
  if (soUserId < 1) {
    this.clientApiError = 'Select the SO API user that will identify actions created through this credential.';
    this.clientApiMessage = '';
    return;
  }

  const mode = this.clientApiForm.environment_mode === 'live' ? 'live' : 'sandbox';
  const payload = {
    name: this.clientApiCreateName,
    brand_id: Number(this.selectedClientApiBrand.brand_id),
    so_user_id: soUserId,
    environment_mode: mode,
    sync_enabled: mode === 'live' && this.clientApiForm.sync_enabled === true,
    status: this.clientApiForm.status || 'active',
    scopes
  };

  this.clientApiLoading = true;
  this.clearClientApiGeneratedCredentials();
  this.clientApiMessage = '';
  this.clientApiError = '';

  if (this.selectedClientApiEditClient) {
    this.clientApiAdmin.updateClient(this.clientApiBaseUrl, this.selectedClientApiEditClient.client_uuid, payload).subscribe({
      next: response => {
        const client = response && response.data ? response.data.client : null;
        if (client) {
          this.clientApiBrandsLoaded[String(client.brand_id)] = true;
          this.mergeClientApiClients([client]);
        }
        this.refreshSelectedBrandClients();
        this.refreshClientApiBadges();
        this.clientApiLoading = false;
        this.clientApiMessage = 'Client API access updated.';
      },
      error: error => this.handleClientApiError(error, 'Client API access could not be updated.')
    });
    return;
  }

  this.clientApiAdmin.createClient(this.clientApiBaseUrl, payload).subscribe({
    next: response => {
      const client = response && response.data ? response.data.client : null;
      this.clientApiGeneratedSecret = response && response.data ? response.data.client_secret : '';
      this.clientApiGeneratedClientUuid = client ? client.client_uuid : '';
      this.clientApiGeneratedClientName = client ? client.name : this.clientApiCreateName;
      this.clientApiGeneratedEnvironment = client ? client.environment_mode : mode;
      this.clientApiGeneratedAt = new Date().toISOString();
      if (client) {
        this.clientApiBrandsLoaded[String(client.brand_id)] = true;
        this.mergeClientApiClients([client]);
      }
      this.refreshSelectedBrandClients();
      this.refreshClientApiBadges();
      this.clientApiLoading = false;
      this.clientApiMessage = 'Client API credentials created. Secret is visible once.';
    },
    error: error => this.handleClientApiError(error, 'Client API credentials could not be created.')
  });
}

editClientApiAccess(client: ClientApiAdminClient): void {
  this.selectedClientApiEditClient = client;
  this.clientApiCreateName = client.name;
  const mappedUserId = Number(client.so_user_id || 0);
  this.clientApiForm.so_user_id = mappedUserId > 0 ? mappedUserId : null;
  this.clientApiForm.environment_mode = client.environment_mode;
  this.clientApiForm.sync_enabled = client.sync_enabled;
  this.clientApiForm.status = client.status;
  this.clientApiScopeOptions.forEach(option => {
    this.clientApiForm.scopes[option.key] = client.scopes.indexOf(option.scope) >= 0;
  });
  this.clearClientApiGeneratedCredentials();
  this.clientApiMessage = 'Editing ' + client.client_uuid + '.';
  this.clientApiError = '';
}

cancelClientApiEdit(): void {
  this.selectedClientApiEditClient = null;
  if (this.selectedClientApiBrand) {
    this.clientApiCreateName = ((this.selectedClientApiBrand && this.selectedClientApiBrand.name) ? this.selectedClientApiBrand.name : 'Client') + ' Client API';
  }
}

rotateClientApiSecret(client: ClientApiAdminClient): void {
  const confirmed = window.confirm(
    'Rotate the Client API secret for ' + client.name + '? Every existing secret and unexpired bearer token for this client will stop working immediately. Every connected application must be updated with the replacement secret.'
  );
  if (!confirmed) {
    return;
  }

  this.clientApiLoading = true;
  this.clearClientApiGeneratedCredentials();
  this.clientApiMessage = '';
  this.clientApiError = '';
  this.clientApiAdmin.rotateSecret(this.clientApiBaseUrl, client.client_uuid, true, true).subscribe({
    next: response => {
      this.clientApiGeneratedSecret = response && response.data ? response.data.client_secret : '';
      this.clientApiGeneratedClientUuid = client.client_uuid;
      this.clientApiGeneratedClientName = client.name;
      this.clientApiGeneratedEnvironment = client.environment_mode;
      this.clientApiGeneratedAt = new Date().toISOString();
      this.clientApiLoading = false;
      this.loadSelectedBrandApiClients(false);
      this.clientApiMessage = 'Client API secret rotated. Save the replacement credentials now; every previous secret and bearer token has been revoked.';
    },
    error: error => this.handleClientApiError(error, 'Client API secret rotation failed.')
  });
}

copyClientApiValue(value: string, label: string): void {
  if (!value) {
    return;
  }

  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(value).then(() => {
      this.clientApiMessage = label + ' copied.';
    }).catch(() => this.copyClientApiValueFallback(value, label));
    return;
  }

  this.copyClientApiValueFallback(value, label);
}

copyClientApiCredentials(): void {
  this.copyClientApiValue(this.clientApiCredentialsText(), 'Client API setup');
}

downloadClientApiCredentials(): void {
  if (!this.clientApiGeneratedSecret || !this.clientApiGeneratedClientUuid) {
    return;
  }

  const content = this.clientApiCredentialsText();
  const blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  const company = this.selectedClientApiBrand && this.selectedClientApiBrand.name
    ? this.selectedClientApiBrand.name
    : this.clientApiGeneratedClientName;
  link.href = url;
  link.download = 'sharmans-client-api-' + this.clientApiSafeFilePart(company) + '-' + this.clientApiSafeFilePart(this.clientApiGeneratedEnvironment) + '-credentials.txt';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
  this.clientApiMessage = 'One-time credential file downloaded. Move it to an approved secret manager, then delete the downloaded plaintext file.';
}

loadClientApiActivity(client: ClientApiAdminClient, showMessage: boolean = true): void {
  this.clientApiLoading = true;
  this.clientApiMessage = '';
  this.clientApiError = '';
  this.selectedClientApiActivityClient = client;
  this.clientApiAdmin.activity(this.clientApiBaseUrl, client.client_uuid, 25).subscribe({
    next: response => {
      this.selectedClientApiActivity = response && response.data ? response.data : null;
      this.clientApiLoading = false;
      if (showMessage) {
        this.clientApiMessage = 'Client API activity loaded.';
      }
    },
    error: error => this.handleClientApiError(error, 'Client API activity failed to load.')
  });
}

environmentModeChanged(): void {
  if (this.clientApiForm.environment_mode !== 'live') {
    this.clientApiForm.sync_enabled = false;
  }
}

clientApiActorUsers(): any[] {
  if (!this.selectedClientApiBrand || !this.users || !this.users.filter) {
    return [];
  }

  const brandId = Number(this.selectedClientApiBrand.brand_id);
  return this.users
    .filter(user => Number(user.brand_id) === brandId && Number(user.user_id) > 0)
    .sort((left, right) => this.clientApiUserName(left).localeCompare(this.clientApiUserName(right)));
}

clientApiUserId(user: any): number | null {
  const userId = Number(user && user.user_id ? user.user_id : 0);
  return userId > 0 ? userId : null;
}

compareClientApiUserIds(left: any, right: any): boolean {
  if (left === null || left === undefined || left === '' || right === null || right === undefined || right === '') {
    return (left === null || left === undefined || left === '') && (right === null || right === undefined || right === '');
  }
  return Number(left) === Number(right);
}

clientApiSelectedActorMissing(): boolean {
  const selectedUserId = Number(this.clientApiForm && this.clientApiForm.so_user_id ? this.clientApiForm.so_user_id : 0);
  return selectedUserId > 0
    && !this.clientApiActorUsers().some(user => Number(user.user_id) === selectedUserId);
}

clientApiActorLabel(userId: any): string {
  const expected = Number(userId || 0);
  const user = this.clientApiActorUsers().find(item => Number(item.user_id) === expected);
  return user ? this.clientApiUserName(user) + ' (user_id ' + expected + ')' : (expected > 0 ? 'user_id ' + expected : 'Not assigned');
}

clientApiUserName(user: any): string {
  const name = [user && user.first_name, user && user.surname]
    .filter(value => value)
    .join(' ')
    .trim();
  return name || (user && (user.username || user.email_address)) || 'SO user';
}

private clearClientApiGeneratedCredentials(): void {
  this.clientApiGeneratedSecret = '';
  this.clientApiGeneratedClientUuid = '';
  this.clientApiGeneratedClientName = '';
  this.clientApiGeneratedEnvironment = '';
  this.clientApiGeneratedAt = '';
}

private copyClientApiValueFallback(value: string, label: string): void {
  const field = document.createElement('textarea');
  field.value = value;
  field.style.position = 'fixed';
  field.style.opacity = '0';
  document.body.appendChild(field);
  field.select();
  document.execCommand('copy');
  document.body.removeChild(field);
  this.clientApiMessage = label + ' copied.';
}

private clientApiCredentialsText(): string {
  const company = this.selectedClientApiBrand && this.selectedClientApiBrand.name
    ? this.selectedClientApiBrand.name
    : '';
  return [
    'Sharmans Client API one-time credentials',
    '',
    'Company: ' + company,
    'API client: ' + this.clientApiGeneratedClientName,
    'Environment: ' + this.clientApiGeneratedEnvironment,
    'Created: ' + this.clientApiGeneratedAt,
    '',
    'CLIENT_API_BASE_URL=' + this.clientApiBaseUrl,
    'CLIENT_API_CLIENT_ID=' + this.clientApiGeneratedClientUuid,
    'CLIENT_API_CLIENT_SECRET=' + this.clientApiGeneratedSecret,
    'CLIENT_API_PORTAL_URL=' + this.clientApiAdmin.portalUrlForBrand(Number(this.selectedClientApiBrand && this.selectedClientApiBrand.brand_id), this.clientApiBaseUrl),
    'CLIENT_API_SAMPLE_APP_URL=' + this.clientApiAdmin.sampleAppUrlFor(this.clientApiBaseUrl),
    '',
    'IMPORTANT',
    '- This secret is displayed once and cannot be retrieved later.',
    '- Store it in the integrating application server-side secret manager or protected environment configuration.',
    '- Never place it in Angular/browser code, a URL, source control, email or a support ticket.',
    '- Open Guide and Swagger from API Access & Controls so the broker can issue the correct authenticated links.',
    '- If this secret was rotated, every previous secret and unexpired bearer token stopped working immediately.',
    '- After secure storage, delete this plaintext file from Downloads and any temporary location.'
  ].join('\r\n');
}

private clientApiSafeFilePart(value: string): string {
  const safe = String(value || '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
  return safe || 'client';
}

clientApiDocsUrl(): string {
  return this.clientApiAdmin.docsUrlFor(this.clientApiBaseUrl);
}

openClientApiDocs(kind: 'docs' | 'openapi' = 'docs'): void {
  const localUrl = kind === 'openapi'
    ? this.clientApiAdmin.openApiUrlFor(this.clientApiBaseUrl)
    : this.clientApiAdmin.docsUrlFor(this.clientApiBaseUrl);

  if (this.clientApiBaseUrl.replace(/\/+$/, '') === this.clientApiAdmin.localBaseUrl.replace(/\/+$/, '')) {
    window.open(localUrl, '_blank', 'noopener');
    return;
  }

  this.clientApiAdmin.docsLinks().subscribe({
    next: response => {
      const data: any = response && response.data ? response.data : {};
      const url = kind === 'openapi' ? data.openapi_url : data.docs_url;
      if (url) {
        window.open(url, '_blank', 'noopener');
      } else {
        this.clientApiError = 'Client API docs link is not configured.';
      }
    },
    error: error => this.handleClientApiError(error, 'Client API docs link failed to load.')
  });
}

openClientApiSwagger(client: ClientApiAdminClient): void {
  this.clientApiAdmin.docsLinks(client.client_uuid).subscribe({
    next: response => {
      const data: any = response && response.data ? response.data : {};
      if (data.client_docs_url) {
        window.open(data.client_docs_url, '_blank', 'noopener');
      } else {
        this.clientApiError = 'Client-specific Swagger link is not configured.';
      }
    },
    error: error => this.handleClientApiError(error, 'Client-specific Swagger link failed to load.')
  });
}

canLaunchClientApiPlayground(client: ClientApiAdminClient): boolean {
  return client.status === 'active' && !client.access_blocked;
}

private openClientApiLaunchWindow(): Window | null {
  const launchWindow = window.open('', '_blank');
  if (!launchWindow || launchWindow.closed) {
    return null;
  }

  launchWindow.document.title = 'Opening My Investigations Corp';
  launchWindow.document.body.style.fontFamily = 'Arial, sans-serif';
  launchWindow.document.body.style.padding = '32px';
  launchWindow.document.body.textContent = 'Opening your secure hosted session...';
  return launchWindow;
}

launchClientApiPlayground(client: ClientApiAdminClient): void {
  if (!this.canLaunchClientApiPlayground(client)) {
    this.clientApiError = 'The hosted playground requires an active, unblocked client. The launched session is always isolated sandbox mode.';
    return;
  }

  const launchWindow = this.openClientApiLaunchWindow();
  if (!launchWindow) {
    this.clientApiError = 'A new window is required so this page stays open. Allow pop-ups for Sharmans.Online, then try again.';
    return;
  }

  this.clientApiLoading = true;
  this.clientApiMessage = '';
  this.clientApiError = '';
  this.clientApiAdmin.playgroundLaunch(client.client_uuid, Number(client.brand_id)).subscribe({
    next: response => {
      const launchUrl = response && response.data ? response.data.launch_url : '';
      this.clientApiLoading = false;
      if (!launchUrl) {
        launchWindow.close();
        this.clientApiError = 'The hosted playground launch URL was not returned.';
        return;
      }
      launchWindow.location.href = launchUrl;
      launchWindow.opener = null;
      launchWindow.focus();
    },
    error: error => {
      launchWindow.close();
      this.handleClientApiError(error, 'The hosted sandbox playground could not be opened.');
    }
  });
}

canLaunchClientApiLiveTest(client: ClientApiAdminClient): boolean {
  return client.status === 'active'
    && !client.access_blocked
    && client.environment_mode === 'live'
    && client.sync_enabled === true
    && client.live_test_enabled === true
    && client.scopes.indexOf('jobs:create') >= 0;
}

launchClientApiLiveTest(client: ClientApiAdminClient): void {
  if (!this.canLaunchClientApiLiveTest(client)) {
    this.clientApiError = 'Live Test requires brand approval and an active, unblocked, sync-enabled Live credential with jobs:create scope.';
    return;
  }

  const launchWindow = this.openClientApiLaunchWindow();
  if (!launchWindow) {
    this.clientApiError = 'A new window is required so this page stays open. Allow pop-ups for Sharmans.Online, then try again.';
    return;
  }
  window.focus();

  const confirmation = window.prompt(
    'LIVE TEST WARNING: this can create real Sharmans jobs, subjects, notes, files, notifications and automation events for ' +
    (this.selectedClientApiBrand && this.selectedClientApiBrand.name ? this.selectedClientApiBrand.name : client.name) +
    '. Type LIVE to continue.'
  );
  if (confirmation !== 'LIVE') {
    launchWindow.close();
    return;
  }

  this.clientApiLoading = true;
  this.clientApiMessage = '';
  this.clientApiError = '';
  this.clientApiAdmin.liveTestLaunch(client.client_uuid, Number(client.brand_id)).subscribe({
    next: response => {
      const launchUrl = response && response.data ? response.data.launch_url : '';
      this.clientApiLoading = false;
      if (!launchUrl) {
        launchWindow.close();
        this.clientApiError = 'The hosted Live Test launch URL was not returned.';
        return;
      }
      launchWindow.location.href = launchUrl;
      launchWindow.opener = null;
      launchWindow.focus();
    },
    error: error => {
      launchWindow.close();
      this.handleClientApiError(error, 'The hosted Live Test could not be opened.');
    }
  });
}

clientApiBadgeVisible(brandId: any): boolean {
  const key = String(brandId || '');
  return this.clientApiAllStateLoaded || this.clientApiBrandsLoaded[key] === true;
}

isClientBrand(brand: any): boolean {
  if (!brand) {
    return false;
  }

  const typeValue = brand.brand_type_key !== undefined && brand.brand_type_key !== null
    ? brand.brand_type_key
    : brand.brand_type_id;
  return Number(typeValue) === 2 || String(typeValue || '').trim().toLowerCase() === 'client';
}

clientApiStatusLabelForBrand(brandId: any): string {
  return this.clientApiStatusLabel(this.clientApiClientsForBrand(brandId));
}

clientApiStatusClassForBrand(brandId: any): string {
  return this.clientApiStatusClass(this.clientApiClientsForBrand(brandId));
}

clientApiTraceText(trace: any): string {
  if (!trace) {
    return '';
  }

  const parts = [];
  ['queue_id', 'job_request_id', 'external_reference', 'so_job_id', 'subject_id', 'subject_number', 'so_user_id', 'api_actor_user_id', 'user_id', 'so_log_id', 'log_type_id', 'driver', 'reason'].forEach(key => {
    if (trace[key] !== undefined && trace[key] !== null && trace[key] !== '') {
      parts.push(key + ': ' + trace[key]);
    }
  });

  if (trace.automation_ids && trace.automation_ids.length) {
    parts.push('automation_ids: ' + trace.automation_ids.join(', '));
  }

  if (trace.executions && trace.executions.length) {
    const executions = trace.executions
      .filter(item => item)
      .map(item => (item.system_automation_id || '?') + ' ' + (item.ok === true ? 'ok' : 'failed') + ' ' + (item.status_code || ''));
    if (executions.length) {
      parts.push('executions: ' + executions.join('; '));
    }
  }

  return parts.join(' | ');
}

private selectedClientApiScopes(): string[] {
  return this.clientApiScopeOptions
    .filter(option => this.clientApiForm.scopes[option.key] === true)
    .map(option => option.scope);
}

private mergeClientApiClients(clients: ClientApiAdminClient[]): void {
  const merged: { [clientUuid: string]: ClientApiAdminClient } = {};
  this.clientApiClients.forEach(client => merged[client.client_uuid] = client);
  clients.forEach(client => merged[client.client_uuid] = client);
  this.clientApiClients = Object.keys(merged).map(key => merged[key]);
  this.rebuildClientApiMap();
}

private rebuildClientApiMap(): void {
  this.clientApiClientsByBrand = {};
  this.clientApiClients.forEach(client => {
    const brandId = String(client.brand_id || '');
    if (brandId === '') {
      return;
    }
    if (!this.clientApiClientsByBrand[brandId]) {
      this.clientApiClientsByBrand[brandId] = [];
    }
    this.clientApiClientsByBrand[brandId].push(client);
  });
}

private refreshClientApiBadges(): void {
  this.applyClientApiState(this.job_table2);
  this.applyClientApiState(this.job_table_clients);
  this.applyClientApiState(this.job_table_agents);
}

private refreshSelectedBrandClients(): void {
  if (!this.selectedClientApiBrand) {
    this.selectedBrandApiClients = [];
    return;
  }

  this.selectedBrandApiClients = this.clientApiClientsForBrand(this.selectedClientApiBrand.brand_id);
}

private applyClientApiState(rows: any): void {
  if (!rows || !rows.forEach) {
    return;
  }

  rows.forEach(row => {
    const clients = this.clientApiClientsForBrand(row.brand_id);
    row.client_api_clients = clients;
    row.client_api_enabled = clients.length > 0;
    row.client_api_status_label = this.clientApiStatusLabel(clients);
    row.client_api_status_class = this.clientApiStatusClass(clients);
  });
}

private clientApiClientsForBrand(brandId: any): ClientApiAdminClient[] {
  const key = String(brandId || '');
  return this.clientApiClientsByBrand[key] || [];
}

private clientApiStatusLabel(clients: ClientApiAdminClient[]): string {
  if (clients.length === 0) {
    return 'API off';
  }
  if (clients.some(client => client.access_blocked)) {
    return 'API blocked';
  }
  if (clients.some(client => client.environment_mode === 'live' && client.sync_enabled && client.status === 'active')) {
    return 'API live sync';
  }
  if (clients.some(client => client.environment_mode === 'live' && client.status === 'active')) {
    return 'API live';
  }
  if (clients.some(client => client.status === 'active')) {
    return 'API sandbox';
  }
  return 'API pending';
}

private clientApiStatusClass(clients: ClientApiAdminClient[]): string {
  if (clients.length === 0) {
    return 'label label-default';
  }
  if (clients.some(client => client.access_blocked)) {
    return 'label label-danger';
  }
  if (clients.some(client => client.environment_mode === 'live' && client.sync_enabled && client.status === 'active')) {
    return 'label label-success';
  }
  if (clients.some(client => client.environment_mode === 'live' && client.status === 'active')) {
    return 'label label-primary';
  }
  if (clients.some(client => client.status === 'active')) {
    return 'label label-info';
  }
  return 'label label-warning';
}

private handleClientApiError(error: any, fallback: string): void {
  const apiErrors = error && error.error && Array.isArray(error.error.errors)
    ? error.error.errors
    : [];
  const primaryError = apiErrors.length ? apiErrors[0] : null;
  const details = primaryError && Array.isArray(primaryError.details)
    ? primaryError.details
    : [];
  const detailMessages = details
    .map(detail => detail && detail.message ? detail.message : '')
    .filter(message => message !== '');
  const responseError = detailMessages.length
    ? detailMessages.join(' ')
    : (primaryError && primaryError.message ? primaryError.message : '');
  this.clientApiError = responseError || fallback;
  this.clientApiMessage = '';
  this.clientApiLoading = false;
}


brandView(brand_id) {
  // this.router.navigate(['/admin/brands/company/view/' + brand_id + '']);
  this.gfunc.globalBrandView(brand_id);
}

brandEdit(brand_id) {
  // this.router.navigate(['/admin/brands/company/edit/' + brand_id + '']);
  this.gfunc.globalbrandEdit(brand_id);
}


userView(user_id) {
  this.router.navigate(['/admin/brands/users/view/' + user_id + '']);
}

userEdit(user_id) {
  this.router.navigate(['/admin/brands/users/edit/' + user_id + '']);
}


}
